<template>
<div class="progress-chart">
  <div class="bar">
    <div
      class="progress-bar"
      :style="{ width: barWidth }">
    </div>
    <div class="bar-mark" style="margin-left: 70%;"></div>
    <div class="bar-mark green"></div>
  </div>
  <div class="requirements">
    <div class="requirement">
      <div class="bar-mark"></div>
      Min: {{ formatMoney(minTarget) }}
    </div>
    <div class="requirement">
      <div class="bar-mark green"></div>
      Max: {{ formatMoney(maxTarget) }}
    </div>
  </div>
  <div class="value">{{ percentage.toFixed(1) }}%</div>
  <div class="description">de la meta minima de {{ formatMoney(minTarget) }}</div>
</div>
</template>

<script>
import formatMixin from '@/mixins/formatMixin';

export default {
  mixins: [formatMixin],
  props: {
    current: String,
    minTarget: String,
    maxTarget: String,
  },
  computed: {
    percentage() {
      let result = 0;
      if (this.minTarget && this.current) {
        result = (parseInt(this.current, 10) / parseInt(this.minTarget, 10)) * 100;
      }
      return result;
    },
    barWidth() {
      if (parseInt(this.current, 10) < parseInt(this.minTarget, 10)) {
        return `${(this.current / this.minTarget) * 72}%`;
      }
      const raisedFixed = this.current - this.minTarget;
      const targetFixed = this.maxTarget - this.minTarget;
      return `${((raisedFixed / targetFixed) * 28) + 72}%`;
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.progress-chart {
  width: 100%;
  margin: -6px 0;
}
.bar {
  margin-top: 25px;
  width: 100%;
  height: 6px;
  max-height: 6px;
  background-color: #dadada;
  overflow: visible;
  display: flex;
  justify-content: space-between;
  border-radius: 100px;
  position: relative;
}
.progress-bar {
  position: absolute;
  min-height: 6px;
  min-width: 1%;
  background-color: #3479e9;
  border-radius: 100px;
}
.bar-mark {
  width: 8px;
  height: 8px;
  background-color: #3479e9;
  background-color: transparent;
  margin-top: -1px;
  border-radius: 50%;
  border: 2px solid #3479e9;
}
.requirements {
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 15px;
  margin-top: 10px;
}
.requirement {
  display: flex;
  align-items: center;

  .bar-mark {
    margin-top: 0;
    margin-right: 6px;
  }
}
.green {
  border-color: #3fc67d;
}
.percentage {
  margin-top: 4px;
}
img {
  width: 22px;
  height: auto;
  margin-left: 93%;
  transform: rotate(180deg);
}
.value {
  font-size: 28px;
  color: #202124;
  margin-top: 28px;
}
.description {
  font-size: 16px;
  color: #5f6368;
  margin-top: 2px;
}
</style>
